import styled from 'styled-components';

export default styled.div`
  && {
    .※ {
      color: rgba(255, 0, 0, 1);
      height: 18px;
      width: 12px;
      margin-right: 4px;
    }
    .info-rental {
      height: 365px;
      background-color: #eeeeee;
      .statistics {
        padding-top: 47px;
        padding-left: 30px;
        .mb-39 {
          margin-bottom: 39px;
        }
      }
    }
    .detail-table-info {
      margin-top: 40px;
    }
    .confirm {
      margin-top: 30px;
      text-align: center;
    }
    .confirm-register-btn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn-save {
        background-color: #ff8a00;
        border-radius: 4px;
        color: white;
        border: none;
        width: 240px;
        height: 60px;
      }
      .btn-cancel-save {
        width: 112px;
        height: 60px;
        background-color: #c4c4c4;
        border-radius: 4px;
        border: none;
        color: white;
        margin-right: 10px;
      }
    }
  }
`;
